import { _axios } from "../../../Utils/Axios/axios";

export const login_Service = async (phone: number) => {
  return _axios.post(
    "/login",
    {
      phone,
    },
    {}
  );
};
